export default __webpack_public_path__ + "bf67d15855b71e67641f785afbe74c59.png";